import { booleanField, stringField, optionField } from '@/common/utils/form/fieldTypes';

export const forms_show_logo = 'forms_show_logo';
export const forms_show_text = 'forms_show_text';
export const logo_text = 'logo-text';
export const logo = 'form_export_header_logo';
export const form_export_header_show_linked_manual = 'form_export_header_show_linked_manual';
export const form_show_header = 'form-show-header';

export type FormsType = {
  forms_show_logo: boolean;
  logo: number[];
  forms_show_text: boolean;
  [logo_text]: string;
  form_export_header_show_linked_manual: boolean;
  [form_show_header]: boolean;
};

const config = {
  [forms_show_logo]: booleanField({ initialValue: false }),
  [logo]: optionField({ initialValue: [] }),
  [forms_show_text]: booleanField({ initialValue: false }),
  [logo_text]: stringField(),
  [form_export_header_show_linked_manual]: booleanField({ initialValue: false }),
  [form_show_header]: booleanField({ initialValue: false })
};

export default config;
